import { useState, useEffect, useContext, useCallback } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import RequirementService from '../Services/RequirementService';
import {extractErrorMessage} from '../Services/RequestService';
import {removeFromCollection, replaceInCollection} from './utils';

export const useRequirements = () => {
    const [requirements, setRequirements] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            let resp = await RequirementService.allRequirements(token);
            setRequirements(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addRequeriment = async (requeriment) => {
        try {
            let resp = await RequirementService.addRequirement(requeriment, token);
            setRequirements([...requirements, resp.data]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateRequeriment = async (requeriment) => {
        try {
            await RequirementService.updateRequirement(requeriment, token);
            setRequirements(replaceInCollection(requeriment, requirements));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteRequeriment = async (requeriment) => {
        try {
            await RequirementService.deleteRequirement(requeriment.id, token);
            setRequirements(removeFromCollection(requeriment, requirements));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const handleServiceWorkerMessage = useCallback(event => {
        if (event.data && event.data.type === 'NEW_MESSAGES_AVAILABLE') {
            let req = requirements.find((requirement) => {
                return requirement.id === event.data.requirementId;
            });
            req = Object.assign({}, req);
            req.newMessages = true;
            setRequirements(replaceInCollection(req, requirements));
        }
    }, [setRequirements, requirements]);

    useEffect(() => {
        loadAll()
    }, []);

    useEffect(() => {
        navigator.serviceWorker.addEventListener('message',handleServiceWorkerMessage);
        return () => {
            navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
        };
    }, [handleServiceWorkerMessage]);

    return [requirements, addRequeriment, updateRequeriment, deleteRequeriment];
}


// WEBPACK FOOTER //
// ./src/Hooks/useRequirements.js